
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/facebook",
      function () {
        return require("private-next-pages/android/local/facebook/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/facebook"])
      });
    }
  